import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomChevronLeft from "@tSurya/Icons/CustomChevronLeft";
import CustomChevronRight from "@tSurya/Icons/CustomChevronRight";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import useEmblaCarousel from "embla-carousel-react";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    fields: {
        img: string;
        title: string;
        imageLink: LinkFieldValue;
    };
}

const enum fields {
    divisions = "divisions",
    header = "header",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.divisions]: Memberlist[];
        [fields.header]: string;
    };
    maxNumberOfColumns: number;
}
type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    ContentImg?: InjectableCss;
    mobileGridView?: InjectableCss;
    container?: InjectableCss;
    twrapper?: InjectableCss;
    parent?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPrev?: ButtonPresentationProps;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    DesktopView?: InjectableCss;
    mobileTitle?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNext?: ButtonPresentationProps;
    nextIcon?: IconPresentationProps;
    button?: LinkPresentationProps;
    Maintitle?: InjectableCss;
    buttonPREV?: InjectableCss;
    buttonNEXT?: InjectableCss;
    Mobiletitle?: InjectableCss;
    parentContainer?: InjectableCss;
    gridViewImages?: GridItemProps;
    wrapperStyles?: InjectableCss;
    subtittle?: InjectableCss;
    Box?: InjectableCss;
    contents?: GridContainerProps;
}

export const imgstyle: Imgstyle = {
    ContentImg: {
        css: css`
            img {
                object-fit: cover;
                aspect-ratio: 1/1;
                width: 100%;
                height: auto;
                max-height: 304px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-height: 170px;
                        `,
                        css`
                            max-height: 170px;
                        `,
                        css`
                            max-height: 304px;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },

    // buttonPrev: {
    //     css: css`
    //         padding: 0;
    //         border: none;
    //         background: transparent;
    //         &:hover {
    //             border: none;
    //             background: transparent;
    //         }
    //     `,
    // },
    // buttonNext: {
    //     css: css`
    //         padding: 0;
    //         border: none;
    //         background: transparent;
    //         &:hover {
    //             border: none;
    //             background: transparent;
    //         }
    //     `,
    // },
    mobileGridView: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
        `,
    },
    Mobiletitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: 28px;
            font-weight: 600;
            line-height: 38px;
            text-align: center;
            margin-bottom: 20px;
            color: ${getColor("text.main")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 24px;
                        margin-bottom: 24px;
                        margin-top: 24px;
                        text-transform: uppercase;
                    `,
                    css`
                        font-size: 24px;
                        margin-bottom: 24px;
                        margin-top: 24px;
                        text-transform: uppercase;
                    `,
                    css`
                        font-size: 24px;
                        margin-bottom: 24px;
                        margin-top: 24px;
                        text-transform: uppercase;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    DesktopView: {
        css: css`
            padding-bottom: 58px;
            opacity: 1;
            position: relative;
            margin: 0 auto;
            margin-top: 40px;
            padding-left: 68px;
            padding-right: 68px;
            max-width: 1440px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                    `,
                    css`
                        padding-left: 0px;
                    `,
                    css`
                        /* padding-left: 0px; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    buttonPREV: {
        css: css`
            padding: 0;
            border: none;
            background: transparent;
            &:hover {
                border: none;
                background: transparent;
            }
        `,
    },
    buttonNEXT: {
        css: css`
            padding: 0;
            border: none;
            background: transparent;
            &:hover {
                border: none;
                background: transparent;
            }
        `,
    },
    Maintitle: {
        css: css`
            display: flex;
            opacity: 1;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: 28px;
            text-align: center;
            justify-content: center;
            line-height: 36px;
            text-transform: uppercase;
            color: ${getColor("text.main")};
            text-transform: uppercase;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin: 0px 30px;
                    `,
                    css`
                        margin: 0px 30px;
                    `,
                    css`
                        margin: 0px 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subtittle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: 23px;
            color: ${COLORS.text.main};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        margin: 0px 30px;
                    `,
                    css`
                        margin: 0px 30px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    prevArrowWrapper: {
        css: css`
            height: 10px;
            position: absolute;
            z-index: 1;
            top: 47%;
            left: -22px;
            left: -28px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 50%;
                        left: 3px;
                    `,
                    css`
                        top: 50%;
                        left: 3px;
                    `,
                    css`
                        top: 50%;
                        left: 3px;
                        left: -13px;
                    `,
                    css``,
                    null,
                ])};
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 47%;
            right: -12px;
            right: -16px;
            right: -22px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 50%;
                        right: 3px;
                    `,
                    css`
                        top: 50%;
                        right: 3px;
                    `,
                    css`
                        top: 50%;
                        right: 3px;
                        right: -23px;
                    `,
                    css``,
                    null,
                ])};
        `,
    },
    twrapper: {
        css: css`
            width: 100%;
            margin-left: 2px;
            margin-bottom: 2px;
            padding-top: 9px;
            padding-bottom: 9px;
            span {
                width: 100%;
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.large};
                line-height: ${TYPOGRAPHY.lineHeight.medium};
                text-align: center;
                color: ${getColor("text.main")} !important;
                text-transform: capitalize;
            }
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            flex: 0 0 auto;
            padding-right: 12px;
            /* width: 25%; */
            padding-left: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        width: 38.13%;
                        width: 50%;
                        width: 51.5%;
                        width: 54.5%;
                        /* width: 100%; */
                    `,
                    css`
                        width: 25%;
                    `,
                    css`
                        width: 25%;
                    `,
                ])};
        `,
    },
    gridViewImages: {
        width: 6,
    },
    parent: {
        css: css`
            display: flex;
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
        `,
    },
    wrapperStyles: {
        css: css`
            position: relative;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 30px;
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            position: relative;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: auto;
            a {
                margin-left: 2px;
                margin-top: 2px;
            }
        `,
    },
    contents: {
        gap: 10,
        css: css`
            div[class^="GridOffset"] {
                width: 100%;
                margin: 0 auto;
                padding: 0 20px;
                > div {
                    justify-content: center;
                    padding-right: 5px;
                    margin-bottom: 28px;
                }
            }
        `,
    },
    mobileTitle: {
        css: css`
            text-align: center;
            font-family: Mulish;
            font-size: 25px;
            display: flex;
            font-style: normal;
            line-height: 10px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: ${getColor("text.main")};
            margin-bottom: 20px !important;
        `,
    },
    main: {
        css: css`
            position: relative;
        `,
    },
};

const styles = imgstyle;

export const SurProductSlides: FC<Props> = ({
    fields,
    // maxNumberOfColumns = fields.divisions.length,
    theme,
    shellContext,
}) => {
    const ctaLinks = useGetLinks(fields.divisions, o => o.fields.imageLink).links;
    const [emblaRef, embla] = useEmblaCarousel();
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = React.useCallback(() => {
        const maxNumberOfColumns = fields.divisions.length || 6;

        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 1;
        } else {
            localSlidesToScroll = 1;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [fields.divisions.length]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();

        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [fields.divisions.length, windowResizeTime]);
    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    useEffect(() => {
        if (!embla) {
            return;
        }

        // embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    React.useEffect(() => {
        onWindowResize();
    }, []);
    useEffect(() => {
        if (!embla || !fields.divisions || fields.divisions.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            // draggable,
            loop: fields.divisions.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.divisions]);

    if (!fields.divisions || fields.divisions.length === 0) {
        return null;
    }
    return (
        <>
            <Hidden below="lg">
                <StyledWrapper {...styles.DesktopView}>
                    <StyledWrapper {...styles.main}>
                        <StyledWrapper {...styles.Box}>
                            <StyledWrapper {...styles.Maintitle}>{fields.header}</StyledWrapper>
                            <StyledWrapper>
                                <Hidden below="sm">
                                    <StyledWrapper>
                                        {fields.divisions.length > 1 && (
                                            <StyledWrapper
                                                {...styles.prevArrowWrapper}
                                                style={{
                                                    display: `${
                                                        slidesToScroll >= fields.divisions.length ? "none" : "block"
                                                    }`,
                                                }}
                                            >
                                                <Button
                                                    {...styles.buttonPREV}
                                                    onClick={() => {
                                                        embla && embla.scrollPrev();
                                                    }}
                                                    disabled={!canScrollPrev}
                                                >
                                                    <ButtonIcon src={CustomChevronLeft} />
                                                </Button>
                                            </StyledWrapper>
                                        )}
                                        <StyledWrapper
                                            {...styles.nextArrowWrapper}
                                            style={{
                                                display: `${
                                                    slidesToScroll >= fields.divisions.length ? "none" : "block"
                                                }`,
                                            }}
                                        >
                                            <Button
                                                {...styles.buttonNEXT}
                                                onClick={() => {
                                                    embla && embla.scrollNext();
                                                }}
                                                disabled={!canScrollNext}
                                            >
                                                <ButtonIcon src={CustomChevronRight} />
                                            </Button>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </Hidden>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.wrapperStyles}>
                            <StyledWrapper {...styles.container} ref={emblaRef}>
                                <StyledWrapper {...styles.parent}>
                                    {fields.divisions?.map((division, index) => {
                                        return (
                                            <>
                                                {division.fields.img && (
                                                    <StyledWrapper {...styles.parentContainer} key={index}>
                                                        <StyledWrapper {...styles.mobileGridView}>
                                                            <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                                <Link
                                                                    href={ctaLinks[index].url}
                                                                    css={css`
                                                                        span {
                                                                            display: flex;
                                                                        }
                                                                    `}
                                                                >
                                                                    <LazyImage
                                                                        {...styles.ContentImg}
                                                                        src={division.fields.img}
                                                                        altText={
                                                                            division.fields.title ||
                                                                            division.fields.img ||
                                                                            ""
                                                                        }
                                                                    />
                                                                </Link>
                                                            </StyledWrapper>
                                                            <StyledWrapper>
                                                                <Link
                                                                    {...styles.twrapper}
                                                                    href={ctaLinks[index].url}
                                                                    role="button"
                                                                >
                                                                    {division.fields.title}
                                                                </Link>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                )}
                                            </>
                                        );
                                    })}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>
            <Hidden above="md">
                <StyledWrapper {...styles.Mobiletitle}>{fields.header}</StyledWrapper>
                <GridContainer {...styles.contents}>
                    {fields.divisions?.map((division, index) => {
                        return (
                            <>
                                {division.fields.img && (
                                    <GridItem {...styles.gridViewImages} key={index}>
                                        <StyledWrapper
                                            css={css`
                                                display: flex;
                                                flex-direction: column;
                                            `}
                                        >
                                            <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                <Link href={ctaLinks[index].url}>
                                                    <LazyImage
                                                        {...styles.ContentImg}
                                                        src={division.fields.img}
                                                        altText={division.fields.title || division.fields.img || ""}
                                                    />
                                                </Link>
                                            </StyledWrapper>
                                            <StyledWrapper>
                                                <Link {...styles.twrapper} href={ctaLinks[index].url} role="button">
                                                    {division.fields.title}
                                                </Link>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </GridItem>
                                )}
                            </>
                        );
                    })}
                </GridContainer>
            </Hidden>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SurProductSlides)),
    definition: {
        group: "Basic",
        displayName: "SurProductSlides",
        fieldDefinitions: [
            {
                name: fields.header,
                displayName: "Header",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                placeholder: "Heading",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Image",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "imageLink",
                        editorTemplate: "LinkField",
                        displayName: "Redirect Link",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
